import React from 'react';
import { Link } from 'react-router-dom';
import SharedNavigation from './SharedNavigation';
import '../styles/PageLayout.css';

const PageLayout = ({ children, className = '' }) => {
  return (
    <div className={`page-layout-root ${className}`}>
      <div className="page-layout-container">
        <SharedNavigation />
        
        {/* Main Content */}
        <div className="page-layout-content">
          {children}
        </div>

        {/* Footer */}
        <footer className="page-layout-footer">
          <div className="page-layout-footer-content">
            <div className="footer-links">
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <span className="footer-separator">•</span>
              <Link to="/terms" className="footer-link">Terms of Service</Link>
            </div>
            <p className="page-layout-footer-text">
              © 2025 AllSportsHubs. Bringing sports communities together.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default PageLayout;